export default __webpack_public_path__ + "static/media/throo.58ea8953.svg";